import React, { useState, useEffect } from "react";
import { getGallery } from "../Service/Api";

import SliderModule from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Slider = SliderModule.default || SliderModule;

function Gallery() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const galleryData = await getGallery();

        if (Array.isArray(galleryData)) {
          setData(galleryData);
        } else {
          setData([]);
        }
      } catch (error) {
        console.log("Error fetching gallery data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const fallbackImage =
    "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/demo.jpg";

  const empty = [
    {
      image: fallbackImage,
      description: "Gallery Title",
    },
    {
      image: fallbackImage,
      description: "Gallery Title",
    },
    {
      image: fallbackImage,
      description: "Gallery Title",
    },
    {
      image: fallbackImage,
      description: "Gallery Title",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,

    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="gallery-section py-5">
      <div className="container-fluid">
        <Slider {...settings}>
          {data.length > 0
            ? data.map((item, index) => {
                const imageUrl = item.attachments?.[0]
                  ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                  : fallbackImage;

                return (
                  <div className="gallery-slide px-2" key={item._id || index}>
                    <div className="gallery-item">
                      {/* Image */}
                      <div className="gallery-img">
                        <img
                          src={imageUrl}
                          alt={item.title || "Gallery"}
                          className="img-fluid w-100"
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = fallbackImage;
                          }}
                        />
                      </div>

                      {/* Description */}
                      <div className="gallery-description">
                        <p>{item.title || "Gallery Title"}</p>
                      </div>
                    </div>
                  </div>
                );
              })
            : empty.map((item, index) => (
                <div className="gallery-slide px-2" key={index}>
                  <div className="gallery-item">
                    {/* Image */}
                    <div className="gallery-img">
                      <img
                        src={item.image}
                        alt={item.description}
                        className="img-fluid w-100"
                      />
                    </div>

                    {/* Description */}
                    <div className="gallery-description">
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
        </Slider>
      </div>
    </div>
  );
}

export default Gallery;
